function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import CoreProvider from "./contexts/provider";
import logger from "./services/logger";
import "./moment";
import "./fontawesome";
/**
 * Initialisation du contexte global
 */

var Index = function Index(_ref) {
  var children = _ref.children,
      editionMode = _ref.editionMode,
      locale = _ref.locale,
      aliasCookie = _ref.aliasCookie,
      coreContext = _ref.coreContext,
      props = _objectWithoutProperties(_ref, ["children", "editionMode", "locale", "aliasCookie", "coreContext"]);

  useEffect(function () {}, [locale]);
  return /*#__PURE__*/React.createElement(CoreProvider, _extends({
    editionMode: editionMode,
    locale: locale,
    aliasCookie: aliasCookie,
    coreContext: coreContext
  }, props), children);
};

Index.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
  editionMode: PropTypes.bool
};
Index.defaultProps = {
  children: null,
  editionMode: false
};
export default Index;